exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-container[data-v-40578b46]{text-align:center;width:100vw;position:absolute;height:1px}.image-container[data-v-40578b46]{width:100%;display:inline-block;margin-top:10vh;display:flex;vertical-align:center;justify-content:center}img[data-v-40578b46]{clip-path:circle(7.5vw at center);margin-top:-3vh;width:20%}span[data-v-40578b46]{margin-right:3vw}p[data-v-40578b46]{text-align:justify;width:70vw;display:inline-block;font-size:3.75vh;margin-top:4.5%;font-family:Gill Sans,Gill Sans MT,Calibri,Trebuchet MS,sans-serif}.appear[data-v-40578b46]{transition:opacity 1s}", ""]);

// exports
